export default Object.freeze({
  0: 'Pending',
  1: 'Active',
  Pending: 0,
  Active: 1
});
